import { styled } from "@linaria/react";
import { colors } from "../../../styles/utils/vars";
import { getTypographyBase, Heading3 } from "../../ui/Typography/Typography";
export const Title = /*#__PURE__*/styled(Heading3)({
  name: "Title",
  class: "Title_t14sc1v9"
});
export const Line = /*#__PURE__*/styled('div')({
  name: "Line",
  class: "Line_l1sxehe0"
});
export const StyledNotice = /*#__PURE__*/styled('article')({
  name: "StyledNotice",
  class: "StyledNotice_sgcqzjf"
});

require("./StyledNotice.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledNotice.tsx");